import { Badge } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';

interface UnlistedDriversCardProps {
  data?: any;
}

const UnlistedDriversCard = ({ data }: UnlistedDriversCardProps) => {
  const summary = data.summary || {};

  const formatDriverCount = (count: number) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {count}
      </Badge>
    );
  };

  const headers = [
    'Are any other persons in the household or business licensed to drive? (App)',
    'Total number of drivers on application',
    'Total number of drivers listed in the prior 12 months',
  ];

  const rows = [
    [
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {summary.isOtherPersonsLicensedToDrive ? 'Yes' : 'No'}
      </Badge>,
      formatDriverCount(summary.totalDriversOnApplication),
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {summary.totalDriversListed12Months}
      </Badge>,
    ],
  ];

  return (
    <DataTableCard
      description="Check to account for any drivers not listed on application."
      headers={headers}
      rows={rows}
    />
  );
};

export default UnlistedDriversCard;
